import { AxiosError, AxiosResponse } from 'axios';
import { Package } from 'src/models';
import instance, { ApiError } from 'src/api';
import {
  GetReportsHeadsetsQueryParams,
  GetReportsHeadsetsResponse,
  ActivateHeadsetSubscriptionParams,
  ActivateHeadsetSubscriptionResponse,
  CancelHeadsetSubscriptionsParams,
  CancelHeadsetSubscriptionsResponse,
} from './reportHeadsets.types';

const headsetsApiPath = (id: string) => `companies/${id}/devices`;

const companyPackagesApiPath = (companyId: string) =>
  `/companies/${companyId}/packages`;

const activateHeadsetSubscriptionApiPath = (
  companyId: string,
  headsetId: string,
) => `${headsetsApiPath(companyId)}/${headsetId}/subscriptions/activate`;

const CancelHeadsetSubscriptionsApiPath = (
  companyId: string,
  headsetId: string,
) => `${headsetsApiPath(companyId)}/${headsetId}/subscriptions/cancel/all`;

export const getReportsHeadsetsAPI = async ({
  params,
}: {
  params: GetReportsHeadsetsQueryParams;
}): Promise<AxiosResponse<GetReportsHeadsetsResponse & ApiError>> => {
  return instance
    .get<GetReportsHeadsetsResponse>('/devices', {
      params,
    })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

export const getPackagesAPI = async ({
  companyId,
}: {
  companyId: string;
}): Promise<AxiosResponse<Package[] & ApiError>> => {
  return instance
    .get<Package[]>(companyPackagesApiPath(companyId))
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

export const activateHeadsetSubscriptionApi = async ({
  companyId,
  headsetId,
  data,
}: ActivateHeadsetSubscriptionParams): Promise<
  AxiosResponse<ActivateHeadsetSubscriptionResponse & ApiError>
> => {
  return instance
    .post<ActivateHeadsetSubscriptionResponse>(
      activateHeadsetSubscriptionApiPath(companyId, headsetId),
      data,
    )
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

export const cancelHeadsetSubscriptionsApi = async ({
  companyId,
  headsetId,
}: CancelHeadsetSubscriptionsParams): Promise<
  AxiosResponse<CancelHeadsetSubscriptionsResponse & ApiError>
> => {
  return instance
    .post<CancelHeadsetSubscriptionsResponse>(
      CancelHeadsetSubscriptionsApiPath(companyId, headsetId),
    )
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
